export const AUTO_SUGGEST_CLASSES = {
    container: 'container',
    containerOpen: 'container--open',
    input: 'input',
    inputOpen: 'input--open',
    inputFocused: 'input--focused',
    suggestionsContainer: 'suggestions-container',
    suggestionsContainerOpen: 'suggestions-container--open',
    suggestionsList: 'suggestions-list',
    suggestion: 'suggestion',
    suggestionFirst: 'suggestion--first',
    suggestionHighlighted: 'suggestion--highlighted',
};

export const ADD_TAGS_KEYCODES = {
    ENTER: 13,
    TAB: 9,
    COMMA: 188,
};

export const DEFAULT_MAX_TAGS = 6;

export const ONLY_LETTERS_NUMBERS_SPACES_REGEX = /^[A-Za-z0-9 -]*$/g;
